import type { TextareaHTMLAttributes } from 'react';

// autoComplete is intentionally omitted. "off" makes iOS and Android treat
// the field as a login or code box and skip autocorrect, even with spellCheck on.
export const messageTextProps = {
  autoCorrect: 'on',
  autoCapitalize: 'sentences',
  spellCheck: true,
} satisfies TextareaHTMLAttributes<HTMLTextAreaElement>;
